class CustomError extends Error {
  constructor(...params) {
    super(...params);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, CustomError);
    }

    this.date = new Date();
  }
}

export class FirebaseError extends CustomError {}
export class InvalidData extends CustomError {}
